import { Button, Col, Flex, Form, Modal, Row, Space } from "antd";
import { useForm } from "antd/es/form/Form";
import { FormInputNumber } from "components/form/FormProvide";
import FormAntd from "components/form/FormProvide/FormAntd";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

function ModalSalaryAccumulate({
    isModalOpen,
    onCancel = () => { },
    onSubmit = () => { },
    initialValues = {},
}) {
    const { t, i18n } = useTranslation();
    const [form] = useForm(null);

    useEffect(() => {
        if (isModalOpen) {
            form.setFieldsValue({
                amount: initialValues?.amount
            });
        }
    }, [isModalOpen, initialValues, form]);

    return (
        <Modal
            open={isModalOpen}
            onCancel={onCancel}
            title={t("year_accumulate_list.label.edit")}
            closable={false}
            maskClosable={false}
            footer={false}
            destroyOnClose
        >
            <FormAntd
                form={form}
                onFinish={(values) => {
                    onSubmit({
                        ...values, type: initialValues?.code
                    })
                    form.resetFields()
                }}
                colon={false}
                initialValues={{
                    ...initialValues, amount: initialValues?.amount
                }}
            >
                <Form.Item>
                    <Space direction="vertical" size={16} style={{ width: "100%" }}>
                        <Flex>
                            <Col span={12}>
                                <Row>
                                    <span style={{ color: "#42526D", fontSize: "16px" }}>{t("year_accumulate_list.label.type")}</span></Row>
                                <Row>
                                    <span style={{ color: "#42526D", fontWeight: "bold" }}>{i18n.language === "en" ? initialValues?.nameEn : initialValues?.name}</span>
                                </Row>
                            </Col>
                            <Col span={12}>
                                {/* <Row>
                                    <span style={{ color: "#42526D", fontSize: "16px" }}>{t("year_accumulate_list.label.system_amount")}</span></Row>
                                <Row>
                                    <span style={{ color: "#42526D" }}>126,000.00</span>
                                </Row> */}
                            </Col>
                        </Flex>
                        <FormInputNumber
                            label={<span style={{ color: "#42526D" }}>{i18n.language === "en" ? "Initial amount if not used since the start of the year (Bath)" : "ยอดตั้งต้น กรณีไม่ได้ใช้ระบบตั้งแต่ต้นปี (บาท)"}</span>}
                            controls={false}
                            placeholder="00.00"
                            size="large"
                            name="amount"
                        />
                        {/* <FormInputNumber
                            label={<span style={{ color: "#42526D" }}>{i18n.language === "en" ? "Initial amount for annual tax (Bath)" : "ยอดตั้งต้น สำหรับคิดภาษีทั้งปี (บาท)"}</span>}
                            controls={false}
                            placeholder="00.00"
                            size="large"
                        /> */}

                        <Row justify="end" style={{ gap: 10 }}>
                            <Button type="default" onClick={() => {
                                onCancel();
                            }}
                                style={{ borderRadius: 8, height: "40px" }}
                            >
                                {t("common.cancel").toUpperCase()}
                            </Button>

                            <Button
                                type="primary" htmlType="submit"
                                style={{ borderRadius: 8, height: "40px", backgroundColor: "var(--button-color)" }}
                            >
                                {t("common.submit").toUpperCase()}
                            </Button>
                        </Row>
                    </Space>
                </Form.Item>
            </FormAntd>
        </Modal >
    )
}

export default ModalSalaryAccumulate;